import { useLang } from "../../App";

export const Nav = () => {
  const { lang, setLang, t } = useLang();
  return (
    <nav className="border-b border-[#1e293b]/70 bg-[#070d1e]/90 backdrop-blur-md sticky top-0 z-40" data-testid="main-nav">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <svg className="w-8 h-8 shrink-0" viewBox="0 0 32 32" aria-hidden="true">
              <circle cx="16" cy="16" r="14" fill="#0f172a" stroke="#fbbf24" strokeWidth="2" />
              <path d="M12 21L16 11L20 21M13.5 18H18.5" stroke="#fbbf24" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <span className="disp text-2xl font-black tracking-tight" data-testid="brand-name">
              <span className="text-[#fbbf24]">i</span><span className="text-white">Credit</span>
            </span>
          </div>
          <span className="mono text-[10px] tracking-widest uppercase bg-[#fbbf24]/10 text-[#fbbf24] px-2.5 py-1 rounded-full border border-[#fbbf24]/30" data-testid="trust-badge">
            TRUSTED SINCE 2015
          </span>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 text-xs mono text-slate-400" data-testid="lang-toggle">
            <button
              data-testid="lang-en-btn"
              onClick={() => setLang("en")}
              className={lang === "en" ? "text-[#fbbf24] font-semibold" : "hover:text-white cursor-pointer"}
            >
              EN
            </button>
            <span>/</span>
            <button
              data-testid="lang-zh-btn"
              onClick={() => setLang("zh")}
              className={lang === "zh" ? "text-[#fbbf24] font-semibold" : "hover:text-white cursor-pointer"}
            >
              中文
            </button>
          </div>
          <a
            href="#apply"
            data-testid="nav-apply-btn"
            className="disp font-semibold text-xs tracking-wider uppercase bg-[#fbbf24] text-[#070d1e] px-5 py-2.5 rounded hover:bg-[#f59e0b] transition-colors"
          >
            {t("nav.apply")}
          </a>
        </div>
      </div>
    </nav>
  );
};
